<template>
  <v-dialog v-model="show" max-width="900px" scrollable>
    <v-card>
      <v-card-title>
        <v-icon left color="info">mdi-chart-bar</v-icon>
        Statistiken: {{ rule?.name }}
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text style="max-height: 70vh;">
        <!-- Statistics Summary -->
        <v-row class="mb-4">
          <v-col cols="12" sm="4">
            <v-card outlined>
              <v-card-text class="text-center">
                <div class="text-h3 primary--text">{{ stats.total_shows || 0 }}</div>
                <div class="text-caption">Gesamt Anzeigen</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined>
              <v-card-text class="text-center">
                <div class="text-h3 success--text">{{ stats.unique_users || 0 }}</div>
                <div class="text-caption">Verschiedene Nutzer</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card outlined>
              <v-card-text class="text-center">
                <div class="text-h3 info--text">{{ stats.unique_orders || 0 }}</div>
                <div class="text-caption">Verschiedene Orders</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Logs Table -->
        <v-card outlined>
          <v-card-title class="subtitle-1">
            Anzeige-Verlauf
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Suchen"
              single-line
              hide-details
              dense
              outlined
              class="mt-0"
              style="max-width: 300px;"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="logHeaders"
            :items="logs"
            :loading="loading"
            :search="search"
            :items-per-page="10"
            class="elevation-0"
          >
            <template v-slot:item.user_name="{ item }">
              <v-chip small>
                <v-icon left small>mdi-account</v-icon>
                {{ item.user_name || `User ${item.user_id}` }}
              </v-chip>
            </template>

            <template v-slot:item.order_id="{ item }">
              <v-chip small color="primary" outlined>
                #{{ item.order_id }}
              </v-chip>
            </template>

            <template v-slot:item.shown_at="{ item }">
              {{ formatDateTime(item.shown_at) }}
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Schließen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PacklistAlertService from '@/services/PacklistAlertService'

export default {
  name: 'PacklistAlertStatsDialog',
  props: {
    value: Boolean,
    rule: Object
  },
  data() {
    return {
      loading: false,
      logs: [],
      stats: {
        total_shows: 0,
        unique_users: 0,
        unique_orders: 0
      },
      search: '',
      logHeaders: [
        { text: 'Nutzer', value: 'user_name', width: '25%' },
        { text: 'Order', value: 'order_id', width: '20%' },
        { text: 'Angezeigt am', value: 'shown_at', width: '35%' },
      ]
    }
  },
  computed: {
    show: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    rule: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.loadStats()
          this.loadLogs()
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadStats() {
      if (!this.rule || !this.rule.id) return

      this.loading = true
      try {
        const response = await PacklistAlertService.getRuleStats(this.rule.id)
        this.stats = response.data.stats
      } catch (error) {
        console.error('Error loading stats:', error)
        this.$toast?.error('Fehler beim Laden der Statistiken')
      } finally {
        this.loading = false
      }
    },
    async loadLogs() {
      if (!this.rule || !this.rule.id) return

      this.loading = true
      try {
        const response = await PacklistAlertService.getRuleLogs(this.rule.id)
        this.logs = response.data.logs
      } catch (error) {
        console.error('Error loading logs:', error)
        this.$toast?.error('Fehler beim Laden der Logs')
      } finally {
        this.loading = false
      }
    },
    formatDateTime(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    close() {
      this.show = false
      this.logs = []
      this.stats = {
        total_shows: 0,
        unique_users: 0,
        unique_orders: 0
      }
      this.search = ''
    }
  }
}
</script>

<style scoped>
.text-h3 {
  font-weight: 600;
}
</style>
